const embroiderySelect = () => {
  const designAnchor = document.querySelectorAll(`.js-design-anchor`);
  const designHiddenInput = document.querySelector(`.js-select-h-input`);
  const designInput = document.querySelector(`.js-select-input`);
  const designList = document.querySelector(`.js-select-list`);

  if (designAnchor.length && designHiddenInput && designInput && designList) {
    const designSelectItems = Array.from(designList.querySelectorAll(`.js-select-item`));

    function onDesignAnchorClick(evt) {
      const self = evt.currentTarget;
      const currentDesignName = self.parentElement.querySelector(`.js-design-name`);

      changeInputsValue(currentDesignName?.dataset.value);
    }

    function changeInputsValue(value) {
      const requiredItem = designSelectItems.find((item) => item.dataset.value === value);
      if (requiredItem) {
        designHiddenInput.value = requiredItem.dataset.value;
        designInput.textContent = requiredItem.textContent;
        requiredItem.classList.add(`select__item--active`);
      }
    }

    designAnchor.forEach((element) => {
      element.addEventListener(`click`, onDesignAnchorClick);
    });
  }
};

export {embroiderySelect};
